var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecisionComponent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.349,
    height: 16.5,
    viewBox: "0 0 13.349 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5921",
    "data-name": "Group 5921",
    transform: "translate(-865.732 -296.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "noun-diamonds-1280950",
    d: "M133.76,18.009a.337.337,0,0,1-.263-.127l-6.07-7.67a.334.334,0,0,1,0-.417L133.5,2.13a.347.347,0,0,1,.526,0l6.074,7.665a.334.334,0,0,1,0,.417l-6.072,7.67a.338.338,0,0,1-.263.127ZM128.119,10l5.641,7.129L139.4,10,133.759,2.88Z",
    transform: "translate(738.646 294.99)",
    stroke: "#333",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecisionComponent);
export default __webpack_public_path__ + "static/media/decision-component.5e03e731684bbc2222ee99ae1c760593.svg";
export { ForwardRef as ReactComponent };